<template>
  <section class="index-chart">
    <nav><button v-for="tab in periods" :key="tab.value" :class="{ active: period === tab.value }" @click="changePeriod(tab.value)">{{ tab.label }}</button></nav>
    <div ref="chart" class="chart"></div>
    <p v-if="error" role="alert">{{ error }} <button @click="createChart">重试</button></p>
  </section>
</template>
<script>
import HQChart from 'hqchart'
import { applyChartPricePrecision } from '@/utils/chartPricePrecision'
import DefaultData from '@/utils/DefaultData'
import { applyChartTheme } from '@/utils/chartTheme'
import { workspaceChartFilter } from '@/utils/workspaceChart'
import { usChartFilter } from '@/utils/usChartData'
import { requestUS } from '@/utils/usQuotes'
import { pollMarket } from '@/utils/marketRefresh'
import { indexMarket } from './indexTrade'
export default {
  props: { stock: Object },
  data: () => ({ period: 4, error: '', chart: null, observer: null, disposed: false, periods: [{ value: 4, label: '分时' }, { value: 5, label: '5日' }, { value: 0, label: '日K' }, { value: 1, label: '周K' }, { value: 2, label: '月K' }] }),
  watch: { 'stock.full_code'() { this.createChart() }, '$store.state.theme'() { this.createChart() }, '$store.state.quoteColorMode'() { applyChartTheme(this.chart, this.$store.state.theme) } },
  mounted() { this.createChart(); this.observer = new ResizeObserver(() => { if (this.chart) this.chart.OnSize() }); this.observer.observe(this.$refs.chart) },
  beforeDestroy() { this.disposed = true; this.chartGeneration++; if (this.stopRefresh) this.stopRefresh(); if (this.observer) this.observer.disconnect(); if (this.chart) this.chart.ChartDestroy() },
  methods: {
    changePeriod(value) { if (this.period === value) return; this.period = value; this.createChart() },
    refreshChart() {
      if (this.disposed || !this.chart) return
      if (this.chartPending) return this.chartPending
      const container = this.chart.JSChartContainer
      if (this.period === 5) container.RequestHistoryMinuteData()
      else if (this.period === 4) container.RequestMinuteData()
      else if (this.chartLoaded) container.RequestRealtimeData()
      else container.RequestHistoryData()
      return this.chartPending
    },
    createChart() {
      if (!this.$refs.chart || !this.stock.full_code || this.disposed) return
      if (this.stopRefresh) this.stopRefresh()
      const generation = this.chartGeneration = (this.chartGeneration || 0) + 1
      if (this.chart) this.chart.ChartDestroy()
      this.chartPending = null; this.chartLoaded = false
      this.$refs.chart.innerHTML = ''; this.error = ''
      const code = this.stock.full_code, us = /^us/.test(code)
      const symbol = us ? code.slice(2) + '.USA' : /^hk/.test(code) ? code.slice(2) + '.HK' : code
      const option = this.period > 2 ? DefaultData.GetMinuteOption() : DefaultData.GetKLineOption()
      if (this.period > 2) option.DayCount = this.period === 5 ? 5 : 1
      else option.KLine.Period = this.period
      option.Symbol = symbol; option.symbol = symbol; option.IsAutoUpdate = false
      const current = () => !this.disposed && generation === this.chartGeneration
      const onError = error => { if (current()) { this.error = error; if (!error) this.chartLoaded = true } }
      const onQuote = qt => { if (current() && qt.zhishu) this.$emit('breadth', { code, breadth: qt.zhishu }) }
      const filter = us ? usChartFilter(code, symbol, onError, requestUS, onQuote, true) : workspaceChartFilter(onError, onQuote, true)
      option.NetworkFilter = (data, callback) => {
        const pending = Promise.resolve(filter(data, value => { if (current()) callback(value) })).catch(() => onError('图表数据暂不可用，请稍后重试'))
        this.chartPending = pending
        pending.finally(() => { if (current() && this.chartPending === pending) this.chartPending = null })
      }
      applyChartTheme(null, this.$store.state.theme)
      this.chart = HQChart.Chart.JSChart.Init(this.$refs.chart); this.chart.SetOption(option); this.chart.OnSize()
      applyChartPricePrecision(this.chart)
      this.stopRefresh = pollMarket(() => this.refreshChart(), 10000, () => indexMarket(this.stock))
    }
  }
}
</script>
<style scoped>
.index-chart { display:flex; flex-direction:column; flex:3; min-height:220px; position:relative; }
nav { display:flex; flex:0 0 36px; background:var(--theme-header); }
button { flex:1; border:0; background:transparent; color:var(--theme-label); font:inherit; cursor:pointer; }
button.active { color:var(--theme-text); border-bottom:2px solid var(--theme-accent); }
.chart { flex:1; min-height:0; position:relative; }
p { position:absolute; top:40px; left:12px; color:var(--theme-muted); background:var(--theme-bg); }
</style>
